/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { View, TouchableOpacity, StyleSheet } from 'react-native';

import formatDate from '../core/support/formatDate';
import { postJSON } from '../support/Fetch';
import AttendanceActions from '../support/AttendanceActions';
import VendorActions from '../support/VendorActions';
import connectData, { ConnectedProps } from '../support/connectData';
import IndexedList from '../support/shared/IndexedList';
import getVendorAttendance from '../support/helpers/getVendorAttendance';
import { canUser } from '../support/shared/permissionHelpers';

import LoadingIndicator from './uiold/LoadingIndicator';
import { Button, Icon, Page, Picker, Text, TextInputSearch } from './uiold';
import Tooltip from './uiold/Tooltip';
import { themeColors } from './uiold/Constants';
import { showSuccess } from './App/AppAlert';
import AttendanceTable, {
  ATTENDANCE_STATUSES,
  VendorAttendance as VendorWithAttendanceAndPlacement,
} from './VendorAttendance/AttendanceTable';
import ExportAttendance, {
  VendorAttendance as VendorWithAttendance,
} from './VendorAttendance/ExportAttendance';
import NotesEditorModal from './VendorAttendance/NotesEditorModal';

import { Market } from '../types/shared/Market';
import { VendorSummaryWithMarkets } from '../types/shared/Vendor';
import { Status } from '../types/shared/Attendance';

import { Link as NavLink } from './Navigation';
import { toMap } from '../support/helpers/toMap';
import { getCategoryOptionsFromFields } from '../support/helpers/CategoryOptions';
import { Option } from '../runtypes/SignupFormDefinitionRuntype';

type State = {
  noteInput: string;
  filterText: string;
  activeDate: string | null;
  isSearching: boolean;
  activeFilter: string | null | undefined;
  vendorFilter: Map<string, any>;
  activeVendorID: string;
  showNotesModal: boolean;
  showExportModal: boolean;
  activeCategory: Option;
  activeMarketID: string | null | undefined;
};
const INPUT_LIMIT = 1000;
const ATTENDANCE_STATUS_ALL = t('All Statuses');
const ATTENDANCE_CATEGORY_ALL = {
  id: 'allCategories',
  name: t('All Categories'),
};
const filters = [ATTENDANCE_STATUS_ALL, ...ATTENDANCE_STATUSES];

class VendorAttendanceView extends Component<FullProps, State> {
  state: State = {
    vendorFilter: new Map(),
    showNotesModal: false,
    showExportModal: false,
    activeCategory: ATTENDANCE_CATEGORY_ALL,
    activeMarketID: null,
    activeFilter: ATTENDANCE_STATUS_ALL,
    activeVendorID: '',
    isSearching: false,
    activeDate: '',
    filterText: '',
    noteInput: '',
  };

  componentDidUpdate(_prevProps: FullProps, prevState: State) {
    if (prevState.activeDate !== this.state.activeDate) {
      let { activeMarketID, activeDate } = this.state;
      let markets = this.props.filteredMarkets || new IndexedList([]);
      let activeMarket =
        (activeMarketID && markets.getByID(activeMarketID)) ||
        markets.getByIndex(0);
      if (activeMarket) {
        this.setState({
          activeDate: activeMarket
            ? activeDate != null &&
              activeMarket.dates.indexOf(activeDate) !== -1
              ? activeDate
              : activeMarket.dates[0] ?? null
            : null,
        });
      }
    }
  }

  render() {
    let {
      activeVendors,
      filteredMarkets,
      markets,
      attendance,
      placement,
      positionMap,
      formDef,
      isDirty,
      isLoading,
      user,
    } = this.props;
    let { activeFilter, activeCategory, filterText, isSearching } = this.state;
    let { activeMarket, activeDate } = this._getActive();

    if (
      !activeVendors ||
      !markets ||
      !filteredMarkets ||
      !attendance ||
      !activeFilter ||
      !activeCategory ||
      !placement ||
      !formDef ||
      isLoading
    ) {
      return (
        <View style={styles.root}>
          <LoadingIndicator />
        </View>
      );
    }

    if (!activeMarket) {
      return (
        <Page>
          <Page.Header title="Attendance" />
          <View style={styles.root}>
            <Text type="label">
              {`You don't have any market dates. `}
              <Link to="/markets">Click Here</Link> to edit your markets.
            </Text>
          </View>
        </Page>
      );
    }

    let categories = [ATTENDANCE_CATEGORY_ALL, ...this._getCategories()];
    let positionByActiveMarket =
      (positionMap && positionMap[activeMarket.id]) || {};

    let attendanceList = getVendorAttendance(
      activeMarket,
      activeVendors,
      placement,
      activeDate,
      attendance,
    );

    const options = getCategoryOptionsFromFields(formDef.fields);
    const optionsMap = toMap(options);

    let filteredVendorsAttendance: Array<VendorWithAttendanceAndPlacement> = activeVendors
      .toArray() // Do not display vendor thats not assigned to a stall.
      .filter((vendor) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        let vendorMarkets = placement![vendor.id] || {};
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        let vendorDates = vendorMarkets[activeMarket!.id] || {};
        let placementIndexes = (activeDate && vendorDates[activeDate]) || [];
        return !!placementIndexes.length;
      }) // Filter the vendors by selected category.
      .filter((vendor) => {
        if (!attendanceList[vendor.id]) {
          return false;
        }

        if (activeCategory.id === ATTENDANCE_CATEGORY_ALL.id) {
          return true;
        }

        if (!vendor.category) {
          return false;
        }

        const vendorCategories = vendor.category;
        return vendorCategories.includes(activeCategory.id);
      }) // Map vendors to include attendance status and
      // placement indexes.
      .map((vendor) => {
        let vendorAttendance = attendanceList[vendor.id];

        let placementIndexes = vendorAttendance
          ? vendorAttendance.placementIndexes.map((placementIndex) => {
              let stallName = positionByActiveMarket[String(placementIndex)];
              // Display stall name if exist, otherwise, just display a number.
              return stallName || String(placementIndex + 1);
            })
          : [];
        return {
          vendor,
          placementIndexes,
          status: vendorAttendance && vendorAttendance.status,
        };
      }) // Filter vendors by selected attendance status.
      .filter((attendance) =>
        activeFilter === ATTENDANCE_STATUS_ALL
          ? true
          : attendance.status === activeFilter,
      ) // Filter vendors by the search query
      .filter(
        ({
          vendor,
          placementIndexes,
          status,
        }: VendorWithAttendanceAndPlacement) =>
          isSearching
            ? [
                // Will only search for match in this array
                placementIndexes.toString(),
                status,
                vendor.name,
                vendor.contact,
                (vendor.category || []).toString(),
              ].some((w) =>
                typeof w === 'string'
                  ? w.toUpperCase().includes(filterText.toUpperCase())
                  : false,
              )
            : true,
      );
    let activeMarketDate;
    let activeMarketDates = activeMarket.dates.map((date) => {
      let marketDate = {
        id: date,
        name: formatDate(date, { fromUTC: true, includeDayOfWeek: true }),
      };
      if (date === activeDate) {
        activeMarketDate = marketDate;
      }
      return marketDate;
    });

    let marketList = filteredMarkets.getList();
    let userCanWrite = canUser(user, { attendance: 'WRITE' });

    return (
      <Page
        isLoading={
          !activeVendors ||
          !markets ||
          !activeMarket ||
          !filteredMarkets ||
          !attendance ||
          !activeFilter ||
          !activeCategory ||
          !formDef ||
          isLoading
        }
      >
        {this.state.showNotesModal && (
          <NotesEditorModal
            internalNotes={this.state.noteInput}
            onSave={this._saveNote}
            onClose={this._onCloseNotesModal}
            user={user}
          />
        )}
        <Page.Header title="Attendance">
          <View style={styles.tableSave}>
            {userCanWrite && isDirty && (
              <Button onPress={this._onSave} title="Save Changes" isPrimary />
            )}
          </View>
        </Page.Header>

        <View style={styles.dropdownWrap}>
          <View style={styles.dropdownLeft}>
            <View style={styles.dropdown}>
              <Picker
                maxWidth={360}
                options={marketList}
                selectedItem={activeMarket}
                onChange={(value) => {
                  this._onMarketSelect(value);
                }}
              />
            </View>
            <View style={styles.dropdown}>
              <Picker
                options={activeMarketDates}
                selectedItem={activeMarketDate}
                onChange={(value) => {
                  this._onDateSelect(value);
                }}
              />
            </View>

            <View style={styles.dropdown}>
              <Picker
                maxWidth={360}
                options={categories}
                selectedItem={this.state.activeCategory}
                onChange={(value) => {
                  this._onCategorySelect(value);
                }}
              />
            </View>

            <View style={styles.dropdown}>
              <Picker
                options={filters}
                selectedItem={this.state.activeFilter ?? undefined}
                onChange={(value) => {
                  this._onFilterSelect(value);
                }}
              />
            </View>

            <View style={styles.dropdown}>
              <Tooltip title="Export">
                <TouchableOpacity
                  onPress={this._toggleExportModal}
                  style={styles.touchableIcon}
                >
                  <Icon size="S" name="export" />
                </TouchableOpacity>
              </Tooltip>
            </View>
          </View>

          <View style={[styles.dropdown, styles.lup]}>
            {isSearching ? (
              <TextInputSearch
                autoFocus={true}
                value={filterText}
                onChangeText={this._onSearchChange}
                onBlur={this._onSearchBlur}
              />
            ) : (
              <TouchableOpacity onPress={this._onSearch}>
                <Icon name="search" size="M" color={themeColors.mainNavText} />
              </TouchableOpacity>
            )}
          </View>
        </View>
        {filteredVendorsAttendance.length === 0 ? (
          <View style={styles.root}>
            <Text type="label">
              No vendors have been placed yet. Please go to{' '}
              <NavLink to={['/placement']} variant="blue">
                Placement
              </NavLink>{' '}
              to place active vendors.
            </Text>
          </View>
        ) : (
          <AttendanceTable
            attendance={filteredVendorsAttendance}
            onVendorStatusChange={(vendorID: string, status: Status) => {
              userCanWrite && this._onStatusChange(vendorID, status);
            }}
            onNotesPress={this._onEditNotesPress}
            optionsMap={optionsMap}
          />
        )}
        {this._renderExportModal()}
      </Page>
    );
  }

  _getCategories = () => {
    const { formDef } = this.props;
    if (!formDef) {
      return [];
    }
    const { fields } = formDef;
    const options = getCategoryOptionsFromFields(fields);
    return options;
  };

  _renderExportModal = () => {
    let {
      attendance,
      filteredMarkets,
      activeVendors,
      tags,
      formDef,
    } = this.props;
    if (
      !this.state.showExportModal ||
      !formDef ||
      !filteredMarkets ||
      !activeVendors
    ) {
      return;
    }

    let exportedVendors: Array<VendorWithAttendance> = [];

    for (let vendor of activeVendors.toArray()) {
      let { markets, category } = vendor;
      let attendanceStatus: { [marketID: string]: ObjectOf<Status> } = {};
      for (let [marketID, dateList] of Object.entries(markets)) {
        if (!category) {
          continue;
        }
        let attendanceDates: { [date: string]: Status } = {};
        for (let date of dateList) {
          let status = attendance?.[marketID]?.[date]?.[vendor.id];
          if (status) {
            attendanceDates[date] = status;
          }
        }
        attendanceStatus[marketID] = attendanceDates;
      }

      exportedVendors.push({ ...vendor, attendance: attendanceStatus });
    }

    let marketList = filteredMarkets.getList();
    return (
      <ExportAttendance
        tags={tags || []}
        categories={this._getCategories()}
        markets={marketList}
        vendors={exportedVendors}
        closeExportModal={this._toggleExportModal}
      />
    );
  };

  _onSearch = () => {
    this.setState({
      isSearching: true,
    });
  };

  _onSearchBlur = () => {
    let { filterText } = this.state;
    if (!filterText) {
      this.setState({
        isSearching: false,
      });
    }
  };

  _onSearchChange = (text: string) => {
    this.setState({ filterText: text });
  };

  _onEditNotesPress = (vendor: VendorSummaryWithMarkets) => {
    let { notes } = vendor;

    this.setState({
      showNotesModal: true,
      activeVendorID: vendor.id,
      noteInput: notes || '',
    });
  };

  _onNotesInputChange = (keyword: string) => {
    this.setState({
      noteInput: keyword,
    });
  };

  _saveNote = (newNote: string) => {
    let { activeVendors } = this.props;
    let { activeVendorID } = this.state;
    if (!activeVendorID || !activeVendors) {
      return;
    }
    let vendor = activeVendors.getByID(activeVendorID);
    if (!vendor) {
      return;
    }
    if (newNote.length > INPUT_LIMIT) {
      return;
    }
    let { notes } = vendor;
    if (notes !== newNote) {
      VendorActions.updateActiveVendor(activeVendorID, { notes: newNote });
      postJSON(`/api/vendors/${activeVendorID}`, { notes: newNote });
    }
    this.setState(
      {
        showNotesModal: false,
        noteInput: '',
        activeVendorID: '',
      },
      () => showSuccess(`Saved Successfully.`),
    );
  };

  _onSave = async () => {
    let response = await this.props.saveAttendance();
    if (response?.success) {
      await this.props.fetchAll();
    }
  };

  _getActive = (): {
    activeMarket: Market | null | undefined;
    activeDate: string | null | undefined;
  } => {
    let { activeMarketID, activeDate } = this.state;
    let markets = this.props.filteredMarkets || new IndexedList([]);
    let activeMarket =
      (activeMarketID && markets.getByID(activeMarketID)) ||
      markets.getByIndex(0);
    return {
      activeMarket,
      activeDate: activeMarket
        ? activeDate != null && activeMarket.dates.indexOf(activeDate) !== -1
          ? activeDate
          : activeMarket.dates[0]
        : null,
    };
  };

  _onCloseNotesModal = () => {
    this.setState({
      showNotesModal: false,
    });
  };

  _toggleExportModal = () => {
    this.setState((state) => {
      return { showExportModal: !state.showExportModal };
    });
  };

  _onMarketSelect = (market: Market) => {
    this.setState({
      activeMarketID: market.id,
      activeDate: market.dates[0]
        ? formatDate(market.dates[0], { includeDayOfWeek: true })
        : '',
    });
  };

  _onDateSelect = (date: { id: string; name: string }) => {
    this.setState({ activeDate: date.id });
  };

  _onFilterSelect = (value: string) => {
    this.setState({
      activeFilter: value,
    });
  };

  _onCategorySelect = (value: Option) => {
    let { vendorFilter } = this.state;
    let newMap = new Map(vendorFilter).set('category', value);
    this.setState({
      activeCategory: value,
      vendorFilter: newMap,
    });
  };

  _onStatusChange = (vendorID: string, status: Status) => {
    let { activeMarket, activeDate } = this._getActive();
    if (!activeMarket || !activeDate) {
      return;
    }

    AttendanceActions.updateAttendance(
      activeMarket,
      activeDate,
      vendorID,
      status,
    );
  };
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    padding: 20,
    backgroundColor: themeColors.backgroundGrey,
  },
  dropdownWrap: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: 10,
  },
  dropdownLeft: {
    flexDirection: 'row',
  },
  dropdown: {
    marginRight: 5,
  },
  tableSave: {
    flex: 1,
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  lup: {
    justifyContent: 'center',
  },
  touchableIcon: {
    borderWidth: 1,
    borderColor: themeColors.borderGrey,
    backgroundColor: themeColors.white,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
    height: 34,
    width: 34,
    marginRight: 7,
  },
});

const connector = connectData()(
  () => ({
    attendance: { dataStoreKey: 'attendance' },
    markets: { dataStoreKey: 'markets' },
    activeVendors: { dataStoreKey: 'vendors/active' },
    placement: { dataStoreKey: 'placement' },
    positionMap: { dataStoreKey: 'position' },
    formDef: {
      dataStoreKey: 'forms/:id',
      params: ['signup'],
    },
    tags: { dataStoreKey: 'tags' },
    user: {
      dataStoreKey: 'user',
    },
  }),
  () => ({
    saveAttendance: { dataStoreKey: 'attendance' },
  }),
  {
    computedProps: {
      filteredMarkets: {
        props: ['markets'],
        compute: (markets: IndexedList<Market> | null | undefined) => {
          if (!markets) {
            return null;
          }
          return markets.filter(
            (market) => market.dates != null && market.dates.length !== 0,
          );
        },
      },
    },
  },
);
type FullProps = ConnectedProps<typeof connector>;
export default connector(VendorAttendanceView);
